import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted, onBeforeUnmount, provide } from 'vue'
import Main from '@/layouts/Main.vue'
import TripModificationFooter from '@/components/TripModificationFooter.vue'
import WizardProgressTracker from '@/components/WizardProgressTracker.vue'
import TripModificationCloseDialog from '@/components/TripModificationCloseDialog.vue'
import TripModificationError from '@/components/TripModificationError.vue'
import tripModification from '@/store/modules/tripModification'
import { TripModificationStep } from '@/models/TripModification'
import { ReservationDetail } from '@/models/dto'
import { TripModificationStepKey } from '@/utils/enum'


export default /*#__PURE__*/_defineComponent({
  __name: 'TripModificationWizard',
  props: {
    reservation: null,
    trip: null
  },
  setup(__props: any) {

const props = __props as {
  reservation: ReservationDetail
  trip?: any
};

provide('removePadding', true)



const value = ref(false)

const subHeader = computed(() => {
  const { managedId, routeName } = props.reservation
  const formattedId = `ID ${managedId}`
  return routeName ? `${routeName} – ${formattedId}` : formattedId
})

const currentStep = computed<TripModificationStep>(() => tripModification.step)

const component = computed(() => currentStep.value?.component)

const showHeader = computed(() => {
  if (isDraftInProgress.value) {
    return false
  }
  return ![TripModificationStepKey.Confirmation, TripModificationStepKey.Application, TripModificationStepKey.SubmissionError].includes(currentStep.value.key)
})

const isDraftInProgress = computed(() => tripModification.isDraftInProgress)

const isDraftCustomerReview = computed(() => tripModification.isDraftCustomerReview)

const close = () => {
  tripModification.setIsOpen(false)
}

onMounted(() => {
  tripModification.setManagedId(props.reservation.managedId)
  tripModification.setRouteName(props.reservation.routeName)
  if (tripModification.isDraftCustomerReview) {
    tripModification.startDraftCustomerReview()
  } else {
    tripModification.start()
  }
})

onBeforeUnmount(() => {
  close()
})

return { __sfc: true,props, value, subHeader, currentStep, component, showHeader, isDraftInProgress, isDraftCustomerReview, close, Main, TripModificationFooter, WizardProgressTracker, TripModificationCloseDialog, TripModificationError, tripModification }
}

})